module.exports = __webpack_public_path__ + "static/maligaya-bread-b553fcb0c4965b98ea1cdd6400017ac1.jpg";